import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { CoreDirectivesModule } from "@app/directives/_core/_core.directives.module";
import { FormsDirectivesModule } from "@app/directives/_forms/_form.directives.module";
import { VTableModule } from "@app/directives/_layout/v-table/v-table.module";
import { LayoutDirectivesModule } from "@app/directives/_layout/_layout.directives.module";
import { MapDirectivesModule } from "@app/directives/_map/_map.directives.module";
import { MiscDirectivesModule } from "@app/directives/_misc/_misc.directives.module";
import { GroupButtonFilterComponent } from "@app/directives/_resourceFilters/filter-bar/group-button-filter/group-button-filter.component";
import { ResourceFiltersDirectivesModule } from "@app/directives/_resourceFilters/_resourceFilters.directives.module";
import { GroupAutocompleteComponent } from "@app/directives/_veri/group-autocomplete/group-autocomplete.component";
import { VeriDirectivesModule } from "@app/directives/_veri/_veri.directives.module";
import { PipesModule } from "@app/_pipes/_pipes.module";
import { GroupDetailComponent } from "./group-editor/group-details/group-details.component";
import { GroupEditorComponent } from "./group-editor/group-editor.component";
import { GroupResourcesComponent } from "./group-editor/group-resources/group-resources.component";
import { GroupHierarchyComponent2 } from "./group-hierarchy/group-hierarchy.component";
import { GroupsListComponent } from "./groups-list/groups-list.component";
import { GroupSaveConfirmationComponent } from "./group-editor/group-save-confirmation/group-save-confirmation.component";
import { VehicleDirectivesModule } from "@app/directives/_vehicle/_vehicle.directives.module";

const privateComponents: any[] = [

];

const publicComponents: any[] = [
    GroupsListComponent,
    GroupEditorComponent,
    GroupDetailComponent,
    GroupResourcesComponent,
    GroupHierarchyComponent2,
    GroupButtonFilterComponent,
    GroupAutocompleteComponent,
    GroupSaveConfirmationComponent
];

const declarations: any[] = [
];

const providers: any[] = [
];

@NgModule({
    imports: [
        CommonModule,
        VeriDirectivesModule,
        LayoutDirectivesModule,
        PipesModule,
        CoreDirectivesModule,
        MiscDirectivesModule,
        FormsDirectivesModule,
        ReactiveFormsModule,
        VTableModule,
        ResourceFiltersDirectivesModule,
        MapDirectivesModule,
        VehicleDirectivesModule
     
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations],
    schemas: []
})
export class GroupsModule {
    constructor() {
    }
}
